"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringsDeserialize = exports.stringDeserialize = exports.deserializeString = void 0;
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
function deserializeString(value, minimumLength, maximumLength) {
    if (typeof value !== 'string')
        throw new Error(`Value "${value}" is not a string`);
    if (value.length === 0)
        throw new Error('String is empty. Not allowed');
    if (minimumLength && value.length < minimumLength)
        throw new Error('String is too short');
    if (maximumLength && value.length > maximumLength)
        throw new Error('String is too long');
    return value;
}
exports.deserializeString = deserializeString;
exports.stringDeserialize = deserializeString;
exports.stringsDeserialize = (0, deserializeArray_1.default)(deserializeString);
